import { useTranslation } from 'react-i18next';
import { Route, useHistory } from 'react-router-dom';

import { useViewerRoles } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import { Button, Jumbo, Tabs } from '@treams/treams-ui';

const LearningHeader = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const roles = useViewerRoles();

	const canReview = roles.isWorkspaceSuperuser || roles.isLearningOfficer;

	return (
		<Jumbo
			title={t('learning.page.title')}
			wide={1180}
			button={
				<Button
					onClick={() => {
						history.push({
							pathname: '/learning/event/create',
							state: {
								backgroundLocation: history.location,
							},
						});
					}}
					title={t('learning.events.navigation.createEvent')}
					icon={<AddIcon />}
					type="primary"
				/>
			}
			footer={
				<Tabs.Container wide={1180}>
					<Route
						path={['/learning', '/learning/event/:id', '/learning/calendar/:year/:month']}
						exact
					>
						{({ match }) => (
							<Tabs.Item
								title={t('learning.events.navigation.upcomingEvents')}
								path="/learning"
								selected={!!match}
							/>
						)}
					</Route>
					<Route path="/learning/me" exact>
						{({ match }) => (
							<Tabs.Item
								title={t('learning.events.navigation.myEvents')}
								path="/learning/me"
								selected={!!match}
							/>
						)}
					</Route>
					{canReview && (
						<Route path="/learning/proposals" exact>
							{({ match }) => (
								<Tabs.Item
									title={t('learning.events.navigation.proposedEvents')}
									path="/learning/proposals"
									selected={!!match}
								/>
							)}
						</Route>
					)}
				</Tabs.Container>
			}
		/>
	);
};

export default LearningHeader;
